import type { SVGProps } from 'react';

const SvgKlaviyoPodcast = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fill={props.color}
      d="M30 16.03c0-1.08-.21-2.14-.63-3.13-.41-.96-.99-1.81-1.73-2.55s-1.6-1.32-2.56-1.72c-.99-.42-2.05-.63-3.14-.63s-2.15.21-3.14.63c-.96.4-1.82.98-2.56 1.72s-1.32 1.6-1.73 2.55c-.42.99-.63 2.04-.63 3.13v.23H2v.09c0 1.04.2 2.05.61 3a7.7 7.7 0 0 0 1.66 2.45c.71.71 1.54 1.26 2.46 1.65a7.75 7.75 0 0 0 6.02 0c.92-.39 1.75-.94 2.46-1.65a7.7 7.7 0 0 0 1.66-2.45c.39-.92.6-1.9.61-2.9H30zm-13.3 3.25c-.38.9-.93 1.7-1.62 2.39s-1.5 1.23-2.4 1.61c-.93.39-1.92.59-2.94.59s-2.01-.2-2.94-.59c-.9-.38-1.71-.92-2.4-1.61a7.5 7.5 0 0 1-1.62-2.39 7.4 7.4 0 0 1-.59-2.83h15.1a7.4 7.4 0 0 1-.59 2.83m-1.98-3.67c.05-.82.23-1.62.56-2.38.36-.86.88-1.63 1.55-2.29a7.2 7.2 0 0 1 2.3-1.54c.89-.37 1.84-.56 2.81-.56s1.92.19 2.81.56c.86.36 1.63.88 2.3 1.54.66.66 1.18 1.43 1.55 2.29.32.76.51 1.55.55 2.38z"
    />
  </svg>
);

export default SvgKlaviyoPodcast;
